export const NUMBER_OF_HELP_CENTERS_PER_FETCH = 10;

export const SORT_ORDER = 'CREATED_DATE_ASCENDING';
